<template>
  <div class="slider-wrapper">
    <div
      id="homepage-upper-slider"
      ref="sliderContainer"
    >
      <!-- Server-rendered slides via slot (preferred for SEO and ref() pattern) -->
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { tns } from 'tiny-slider/src/tiny-slider'
import { useUpperSliderStore } from '../stores'

const sliderContainer = ref<HTMLElement | null>(null)
const sliderStore = useUpperSliderStore()

onMounted(() => {
  nextTick(() => {
    // Check if there are any slides (server-rendered via slot)
    const slideElements = sliderContainer.value?.querySelectorAll('.benefits-slider-box')

    if (slideElements && slideElements.length > 0) {
      const instance = tns({
        container: '#homepage-upper-slider',
        responsive: {
          0: { items: 2 },
          750: { items: 3 },
          1350: { items: 5 }
        },
        slideBy: 1,
        gutter: 20,
        controls: false, // Disable default controls - we use custom arrows
        autoplay: false,
        nav: false
      } as any)

      // Store the instance in Pinia store for external navigation
      sliderStore.setSliderInstance(instance)
    }
  })
})

onUnmounted(() => {
  // Clean up the slider instance when component is destroyed
  sliderStore.destroy()
})
</script>
